import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowTriangleBottom"><Path d="M17.252 4.75H6.74803C5.26465 4.75 4.29985 6.31162 4.96324 7.63887L10.2152 18.1465C10.9506 19.6178 13.0494 19.6178 13.7848 18.1466L19.0368 7.63888C19.7001 6.31162 18.7354 4.75 17.252 4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
